<template>
  <div>
    <section class="md:min-h-[450px] h-full w-full relative">
      <div>
        <div class="h-full fixed top-0 left-0 w-full -z-20"></div>
      </div>
      <div class="h-full max-w-7xl mx-auto">
        <div class="">
          <div class="text-black text-start md:py-2 md:px-1 lg:px-5 px-5">
            <div
              class="max-w-7xl mx-auto w-full py-1 pt-1.5 text-[10px] md:text-[14px] line-clamp-1"
            >
              <router-link
                :to="{ name: 'home' }"
                class="border-b border-[#F8C300]"
                >Home</router-link
              >&nbsp; <span>></span>&nbsp;
              <router-link
                :to="{ name: 'BlogsView' }"
                class="border-b border-[#F8C300]"
                >Blogs</router-link
              >&nbsp; <span>></span>&nbsp;
              <span>{{ blog.title }}</span>
            </div>
          </div>

          <div
            class="flex flex-col md:flex-col lg:flex-row lg:gap-5 lg:px-5 space-y-5 lg:space-y-0 p-5 lg:p-0"
          >
            <div class="space-y-3 w-full lg:w-[70%]">
              <div class="w-full flex justify-end">
                <img
                  :src="blog.image"
                  alt=""
                  srcset=""
                  class="h-full w-full rounded-md object-contain"
                />
              </div>
              <div class="flex flex-col gap-2 text-left">
                <h1 class="text-black flex-wrap md:text-[24px] font-bold">
                  {{ blog.title }}
                </h1>

                <p class="text-[14px] flex gap-3 items-center">
                  {{ formatDate(blog.publish_at) }}
                  <span class="h-[6px] w-[6px] rounded-full bg-black"></span>
                  {{ blog.category.title }}
                </p>
              </div>
            </div>

            <div class="lg:w-[25rem] w-full space-y-3 md:block hidden">
              <h2 class="text-black text-2xl text-left font-bold">
                Trending Now
              </h2>

              <div
                class="bg-white p-4 rounded-lg text-left border h-[140px] drop-shadow-lg"
                v-for="blog in trending.slice(0, 3)"
                :key="blog.id"
              >
                <a :href="`/blogs/${blog.slug}`">
                  <h2 class="text-[#1F1F1F] flex-wrap font-semibold">
                    {{ blog.title }}
                  </h2>
                  <p class="text-[14px] text-[#454545] flex gap-3 items-center">
                    {{ formatDate(blog.publish_at) }}
                    <span class="h-[6px] w-[6px] rounded-full bg-black"></span>
                    {{ blog.category.title }}
                  </p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Artical list -->
    <section class="max-w-7xl w-full mx-auto px-5 py-3 blogs">
      <div
        v-html="blog.content"
        class="text-start p-8 md:p-5 lg:w-[67%] 2xl:w-[67.5%] bg-white rounded-lg shadow-lg"
      ></div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "BannerView",

  data() {
    return {
      blog_value: [],
      trending: [],
    };
  },
  props: ["blog"],

  created() {
    this.fetchTrendingBlogs();
    this.pushDataLayer();
  },

  methods: {
    fetchTrendingBlogs() {
      axios
        .get(`${process.env.VUE_APP_API}/blog/blog-list/?trending=true`)
        .then((response) => {
          this.trending = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching trending blogs:", error);
        });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const options = { month: "long", day: "2-digit", year: "numeric" };
      return date.toLocaleDateString("en-US", options);
    },
    pushDataLayer() {
      dataLayer.push({
        "event": "Blog Viewed",
        "Attribute": {
          "Blog Title": this.blog.title,
          "Blog ID": this.blog.id,
        },
      });
    },
  },
};
</script>

<style></style>
